// extracted by mini-css-extract-plugin
module.exports = {"container":"change-language_container__22HAz","container__lang":"change-language_container__lang__1AK82","container__flagIcon":"change-language_container__flagIcon__dIcqS"};